import type { FollowListRow } from '../api/people'

export function filterFollowRows(rows: FollowListRow[], query: string): FollowListRow[] {
  const q = query.trim().toLowerCase()
  if (!q) return rows
  return rows.filter((row) => {
    const handle = row.handle?.toLowerCase() || ''
    const name = row.display_name?.toLowerCase() || ''
    return handle.includes(q) || name.includes(q)
  })
}

export function applyFollowToggle(row: FollowListRow, nextIsFollowing: boolean): FollowListRow {
  const delta = nextIsFollowing ? 1 : -1
  const nextFollowers = Math.max(0, row.followers_count + delta)
  const is_followed_by_viewer = nextIsFollowing
  const is_mutual = Boolean(is_followed_by_viewer && row.is_following_viewer)
  return {
    ...row,
    followers_count: nextFollowers,
    is_followed_by_viewer,
    is_mutual,
  }
}
